export default "__VITE_ASSET__tJqoQ6AQ__"